import { Tooltip } from "@material-ui/core"
import ArchiveIcon from "@mui/icons-material/Archive"
import StarIcon from "@mui/icons-material/Star"
import VisibilityIcon from "@mui/icons-material/Visibility"
import React from "react"
import UserInsightDialog from "../../../components/UserInsights/UserInsightDialog"
import { INSIGHT_STATUS } from "../../constants"
import { getFormattedTimeString } from "../../time"
import { DATA_SCOPES, FILTER_TYPE } from "../filterConstants"
import { DateFilter } from "../filterTypes/dateFilter"
import { ElementFilter } from "../filterTypes/elementFilter"
import { ListFilter } from "../filterTypes/listFilter"
import { NumberFilter } from "../filterTypes/numberFilter"
import { PercentFilter } from "../filterTypes/percentFilter"
import { StringFilter } from "../filterTypes/stringFilter"

export class InsightClassNameFilter extends StringFilter {
  constructor(visibility, restrictedToScope, allowCompare) {
    super(
      "Primary Class Name",
      FILTER_TYPE.INSIGHT.CLASS_NAME,
      [DATA_SCOPES.INSIGHT],
      null,
      visibility,
      restrictedToScope,
    )
    if (allowCompare) {
      this.setCompareWithParameters(FILTER_TYPE.INSIGHT.ALL_CLASS_NAMES, "Less Likely:")
    }
  }

  formatData(_device, _deviceGroups, insight, _insightMetrics, _update, _alert) {
    return insight.class_name.toLowerCase()
  }
}

export class InsightAllClassNamesFilter extends ListFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Possible Class Names",
      FILTER_TYPE.INSIGHT.ALL_CLASS_NAMES,
      [DATA_SCOPES.INSIGHT],
      "Possible class names from most likely to least likely.",
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, insight, _insightMetrics, _update, _alert) {
    return insight.collection
      ? insight.class_list.map((cl) => cl.className.toLowerCase())
      : [insight.class_name.toLowerCase()]
  }
}

export class InsightAlgIdFilter extends NumberFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Alg ID",
      FILTER_TYPE.INSIGHT.ALG_ID,
      [DATA_SCOPES.ALL],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, insight, _insightMetrics, _update, _alert) {
    return insight.alg_id
  }
}

export class InsightConfidenceFilter extends PercentFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Confidence",
      FILTER_TYPE.INSIGHT.CONFIDENCE,
      [DATA_SCOPES.ALL],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, insight, _insightMetrics, _update, _alert) {
    return insight.confidence
  }
}

export class InsightTimeStampFilter extends DateFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Received At (UTC)",
      FILTER_TYPE.INSIGHT.TIMESTAMP,
      [DATA_SCOPES.INSIGHT],
      "When our servers received the insight.",
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, insight, _insightMetrics, _update, _alert) {
    return getFormattedTimeString(insight.time_stamp)
  }
}

export class InsightFileCTimeFilter extends DateFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Camera Timestamp",
      FILTER_TYPE.INSIGHT.FILE_CTIME,
      [DATA_SCOPES.INSIGHT],
      "The insight's file creation time set by the trail camera.",
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, insight, _insightMetrics, _update, _alert) {
    return getFormattedTimeString(insight.file_ctime)
  }
}

export class InsightCommsSourceFilter extends StringFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Comms Source",
      FILTER_TYPE.INSIGHT.COMMS_SOURCE,
      [DATA_SCOPES.ALL],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, insight, _insightMetrics, _update, _alert) {
    return insight.comms_source
  }
}

export class InsightImageFilter extends ElementFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Image",
      FILTER_TYPE.INSIGHT.IMAGE,
      [DATA_SCOPES.ALL],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, insight, _insightMetrics, _update, _alert) {
    return {
      element: <UserInsightDialog isMobile={false} insight={insight} />,
      orderValue: insight.photoUrl ? 1 : 0,
    }
  }
}

export class InsightStatusFilter extends ElementFilter {
  constructor(visibility, restrictedToScope) {
    super(
      "Status",
      FILTER_TYPE.INSIGHT.STATUS,
      [DATA_SCOPES.ALL],
      null,
      visibility,
      restrictedToScope,
    )
  }

  formatData(_device, _deviceGroups, insight, _insightMetrics, _update, _alert) {
    const status = insight.insight_status
    const dataMap = {}
    switch (status) {
      case INSIGHT_STATUS.FAVORITE:
        dataMap.element = (
          <Tooltip title={INSIGHT_STATUS.FAVORITE}>
            <StarIcon />
          </Tooltip>
        )
        dataMap.orderValue = 1
        break
      case INSIGHT_STATUS.ACKNOWLEDGE:
        dataMap.element = (
          <Tooltip title={INSIGHT_STATUS.ACKNOWLEDGE}>
            <VisibilityIcon />
          </Tooltip>
        )
        dataMap.orderValue = 3
        break
      case INSIGHT_STATUS.ARCHIVE:
        dataMap.element = (
          <Tooltip title={INSIGHT_STATUS.ARCHIVE}>
            <ArchiveIcon />
          </Tooltip>
        )
        dataMap.orderValue = 4
        break
      default:
        dataMap.orderValue = 2
        break
    }
    return dataMap
  }
}
